// extracted by mini-css-extract-plugin
export var centerText = "_8q-8";
export var container = "_8q-0";
export var doughnutContainer = "_8q-7";
export var legend = "_8q-a";
export var legendItemColorDisplay = "_8q-b";
export var legendItemLabel = "_8q-d";
export var legendItemValue = "_8q-c";
export var lg = "_8q-5";
export var maxWidth = "_8q-9";
export var md = "_8q-4";
export var responsive = "_8q-6";
export var sm = "_8q-3";
export var xs = "_8q-2";
export var xxs = "_8q-1";